module.exports = __webpack_public_path__ + "static/e_large-c4520b0135bac543a90896745f8184a7.jpg";